module.exports = __webpack_public_path__ + "fonts/PPAgrandir-GrandHeavy.c0ff5416.woff2";